export const KIBANA_MESSAGES = {
    PressureObserver: 'Pressure Observer',
    PictureInPicture: 'PictureInPicture',
    RemoteControlDataStuck: 'Data channel stuck',
    RemoteControlDataSTUNCred: 'Data channel stun credentials',
    RoomDisconnected: 'Room disconnected',
    AudioProblemMediaRestarted: 'Media session restarted with TURN',
    AudioProblemNoAudio: 'Detected no audio',
    LowBandwidthByCPU: 'Low bandwidth',
    UserNetworkStatus: 'User network status',
    NoAudioCopyText: 'NotificationNoAudio: Copy text clicked',
    NoAudioMoreNumbers: 'NotificationNoAudio: More numbers clicked',
    NoAudioDetectProblem: 'NotificationNoAudio: Detected problem with audio',
    TutorialRunByStep: 'Tutorial run by step and type',
    TutorialRunByStage: 'Tutorial run dialog stage',
    TranscriptionEnabledByLang: 'Transcription enableTranscriptionByLang',
    TranscriptionOFF: 'Transcription off',
    TranscriptionWrongLanguage: 'Transcription: WrongTranscriptionLanguageDetector',
    QualityControlOverride: 'QualityControlOverride',
    Visitors: 'Visitors',
    audioAnalytics: (value) => `Audio analytics: ${value}`
};
export const NUMBER_ELEMENTS_TO_SEND = 3;
export const WILDIX_PLATFORMS = {
    RN_XBEES: 'ReactNative xbees',
    RN_COLLABORATION: 'ReactNative collaboration',
    WEB_COLLABORATION: 'Web collaboration',
    WEB_XBEES: 'Web xbees',
    WIZY_HW: 'WizyHW'
};
